import { render, staticRenderFns } from "./checkbox-text.vue?vue&type=template&id=32d34c99"
import script from "./checkbox-text.vue?vue&type=script&lang=ts"
export * from "./checkbox-text.vue?vue&type=script&lang=ts"
import style0 from "./checkbox-text.vue?vue&type=style&index=0&id=32d34c99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports